export default __webpack_public_path__ + "static/media/kit_04.82f65812.jpg";